import CopyIcon from "@mui/icons-material/ContentCopy";
import InviteIcon from "@mui/icons-material/EmailOutlined";
import PartnerIcon from "@mui/icons-material/Handshake";
import PreviewIcon from "@mui/icons-material/Preview";
import { alpha, useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import { getCommunicationTemplateDescription, isValidUUID } from "../../utils/helpers";
import OmniAvatar from "../ui/omniAvatar";
import OmniListItemButton from "../ui/omniListItemButton";

const OmniCommunicationTemplateListItem = props => {
  const { communicationTemplateODM, onClickHandler = null, onCopyHandler } = props;
  const theme = useTheme();

  const getCommunicationTemplateIcon = communicationTemplateODM => {
    if (
      communicationTemplateODM.omniData.communicationTarget ===
      constants.communicationTargets[0].value
    ) {
      return <InviteIcon />;
    } else {
      return <PartnerIcon />;
    }
  };

  return (
    <ListItem
      disableGutters={true}
      sx={[
        {
          padding: theme.spacing(1),
          paddingTop: 0,
          paddingBottom: 0,
          marginBottom: theme.spacing(1),
          borderRadius: theme.spacing(1),
          color: theme.palette.info.contrastText,
          cursor: "pointer",
          boxShadow: theme.shadows[3],
          userSelect: "none",
          webkitUserSelect: "none",
          backgroundColor: alpha(theme.palette.info.main, 0.75),
        },
      ]}
      onClick={e => {
        e.stopPropagation();
        if (onClickHandler) {
          onClickHandler(communicationTemplateODM);
        }
      }}
    >
      {isValidUUID(communicationTemplateODM._id) && (
        <Tooltip title={"No Notes"} placement="right">
          <>
            <OmniAvatar
              sx={{
                width: 36,
                height: 36,
                fontSize: "1.2rem",
                color: theme.palette.info.main,
                border: `2px solid ${theme.palette.info.contrastText}`,
              }}
            >
              {getCommunicationTemplateIcon(communicationTemplateODM)}
            </OmniAvatar>
          </>
        </Tooltip>
      )}
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
            }}
          >
            {getCommunicationTemplateDescription(communicationTemplateODM)}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
            }}
          >
            {`Subject: ${communicationTemplateODM.omniData.subject}`}
          </Typography>
        }
      />
      <OmniListItemButton
        title={"Preview Template"}
        sx={{
          marginTop: "1px",
          marginRight: "1px",
        }}
        size="large"
        onClick={e => {
          e.stopPropagation();
          window.open(communicationTemplateODM.omniData.templateUrl, "_blank", "noreferrer");
        }}
        icon={<PreviewIcon />}
      />
      <OmniListItemButton
        title={"Copy Template"}
        sx={{
          marginTop: "1px",
          marginRight: "42px",
        }}
        size="large"
        onClick={e => {
          e.stopPropagation();
          onCopyHandler(communicationTemplateODM);
        }}
        icon={<CopyIcon />}
      />
    </ListItem>
  );
};

export default OmniCommunicationTemplateListItem;
